import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=7b48e423&scoped=true"
import script from "./PublishModal.vue?vue&type=script&lang=js"
export * from "./PublishModal.vue?vue&type=script&lang=js"
import style0 from "./PublishModal.vue?vue&type=style&index=0&id=7b48e423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b48e423",
  null
  
)

export default component.exports